import { AnyAction, configureStore, ThunkAction } from "@reduxjs/toolkit";
import usersReducer from "src/slices/users";
import invoicesReducer from "src/slices/invoices";
import subscriptionsReducer from "src/slices/subscriptions";
import ordersReducer from "src/slices/orders";
import redeemRequestsReducer from "src/slices/redeemRequests";

export const store = configureStore({
  reducer: {
    usersReducer,
    invoicesReducer,
    subscriptionsReducer,
    ordersReducer,
    redeemRequestsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, AnyAction>;
